<template>
  <page-layout-full class="ai-test-view" view="sm">
    <template #title> ИИ-агент: тестовые страницы </template>

    <template #subtitle>
      Два разных подхода к ИИ-консультанту на сайте — чтобы вживую сравнить, что
      они дают.
    </template>

    <div class="ai-test-view__list">
      <article
        v-for="option in options"
        :key="option.route"
        class="ai-test-view__item"
      >
        <h3 class="ai-test-view__title">{{ option.title }}</h3>
        <p class="ai-test-view__text">{{ option.text }}</p>

        <base-btn :to="{ name: option.route }" tag="router-link">
          Открыть
        </base-btn>
      </article>
    </div>
  </page-layout-full>
</template>

<script>
import PageLayoutFull from "@/components/page/PageLayoutFull.vue";
import BaseBtn from "@/components/shared/BaseBtn.vue";

export default {
  components: {
    PageLayoutFull,
    BaseBtn,
  },
  data() {
    return {
      options: [
        {
          route: "ai-test-chat",
          title: "Свой чат на YandexGPT",
          text: "Модель Яндекса через наш сервер: промпт, история и логи под нашим контролем, дальше сюда можно подключить каталог, цены и остатки.",
        },
        {
          route: "ai-test-widget",
          title: "Готовый виджет Яндекса",
          text: "Коробочный Нейросаппорт: ставится скриптом и работает на базе знаний Яндекса, но выдаётся только по заявке и не видит наших данных.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.ai-test-view {
  &__list {
    display: grid;
    gap: 1.2rem;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }

  &__item {
    border: 1px solid $grey-300;
    border-radius: 8px;
    padding: 1.4rem;
  }

  &__title {
    margin-bottom: 0.6rem;
  }

  &__text {
    color: $stone;
    margin-bottom: 1.2rem;
  }
}
</style>
